import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import iconClose from '../../assets/images/iconClose.svg'
// import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { ClearButton, AsyncTypeahead, Typeahead } from 'react-bootstrap-typeahead';
import { Form } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
//import {getUserTimeZone} from '../../utils/userGroupUrlCheck';
//import {converDateToLocal} from '../../utils/commonUtilities';
import ReactHtmlParser from 'react-html-parser';
import ClientContactAdd from '../client/tabContent/clientContactAdd';
import { validationMsgEventAdd } from '../../configs/validationConfigs';
import { formValid, validateEmail } from '../../utils/validation';
import { titleCase } from '../../utils/changeCase';
import * as types from '../../actions';
import LocationSearchInput from '../commons/helpers/googleLocationSearch';
import Toast from '../commons/helpers/toast';
// import ModalWindow from '../commons/helpers/modalWindow';
import QuickAdd from '../client/quickAdd';
import { clientQuickAddAction, clientCategoryList } from '../../actions/clientActions';
import { clearAction } from '../../actions/commonActions';
import { aflt_departmentsListAction } from "../../actions/settings/affiliates/aflt_departmentActions";

import { LBL_CLIENT, LBL_EVENT, LBL_PO, LBL_QUOTE, LBL_VENUE, LBL_EDIT_EVENT, LBL_CLIENT_CONTACT, LBL_ADD_NEW_CONTACT, LBL_CLIENT_DETAILS, LBL_CONTACT_DETAILS, LBL_PROJECT_DETAILS, LBL_CANCEL, LBL_FINISH_QUOTE } from '../../configs/labelConfigs'; 
// LBL_ADD_NEW_CLIENT LBL_ADD_NEW_CLIENT_CONTACT
import { DISABLE_LOC_DET_EDIT, EVENT_STATUS_ONGOING, EVENT_STATUS_COMPLETED, EVENT_STATUS_CANCELLED, EVENT_STATUS_INVOICED } from '../../configs/staticConfigs';

import { MSG_NO_VERIFICATION_CLIENT_ADD_SUCCESS, MSG_CLIENT_ADD_SUCCESS, MSG_REQUIRED } from '../../configs/msgConfigs';
import CustomTitle from '../commons/helpers/customTitle';
import CommonSlider from '../commons/helpers/CommonSlider';

class QuoteAdd extends Component {

    constructor() {
        super()

        this.state = {
            clientId: 0,
            toastMessagePop: '',
            toastFlagPop: false,
            toastSuccessPop: true,
            saveFormDataClicked: 0,
            addContactClicked: 0,
            clientSelected: [],
            eventNoEditStatuses: [EVENT_STATUS_ONGOING, EVENT_STATUS_COMPLETED, EVENT_STATUS_INVOICED,  EVENT_STATUS_CANCELLED],
            formErrors: {
                companyName: '',
                departments: '',
                firstName: '',
                lastName: '',
                contactNumber: '',
                emailAddress: '',
                category: MSG_REQUIRED
            },
            quickData: {
                companyName: null,
                departments: [],
                websiteUrl: '',
                firstName: null,
                lastName: null,
                contactNumber: null,
                emailAddress: null,
                position: '',
                category: null,
                sendEmailVerification: false
            },
            clientCategoryAPICalled: 0,
            isClientAddSliderOpen: false,
            isContactAddSliderOpen: false,
            departmentsList: [],
            deptMultiSelList: [],
        }
        this.contactModal = React.createRef();
        this.modal = React.createRef();
    }

    loadMultiSelDeptValues() {
        let allDept = [];
        if (this.state.departmentsList.length > 0) {
            let tmpObj = {};
            let len = this.state.departmentsList.length;
            let deptId = 0;
            this.state.departmentsList.forEach((item, index) => {
                if (len === 1) {
                    tmpObj = { value: item.id, label: titleCase(item.name), inputVal: item.id };
                    deptId = item.id;
                }
                else {
                    tmpObj = { value: item.id, label: titleCase(item.name) };
                }
                allDept.push(tmpObj);
            })

            // IF ONLY ONE DEPARTMENT IS THERE - SELECT IT BY DEFAULT 
            if (len === 1 && deptId > 0) {
                let actUserData = this.state.quickData;
                actUserData.departments = [deptId];
                let formErrors = this.state.formErrors;
                formErrors.departments = '';
                this.setState({ quickData: actUserData, deptMultiSelList: allDept, formErrors });
            }
            else {
                this.setState({ deptMultiSelList: allDept });
            }
        }
    }

    handleChangeMultiSel = (selectedDepts) => {
        let actUserDept = [];
        selectedDepts.forEach((item) => {
            actUserDept.push(item.value);
        });
        let actUserData = this.state.quickData;
        actUserData.departments = actUserDept;

        let formErrors = this.state.formErrors; // department  
        actUserData.departments = actUserDept;
        formErrors.departments = actUserDept.length === 0 ? MSG_REQUIRED : '';
        this.setState({ quickData: actUserData, formErrors });
    }

    handleClientChange = (s) => {
        let clientId = 0;
        if (Array.isArray(s) && s.length) clientId = s[0].id;
        this.setState({ clientId: clientId, clientSelected: s }, () => {
            this.props.handleClientChange(s);
        });
    }

    onCloseToastPop = () => { // USED FOR POPUP clientContactAdd
        this.setState({ toastFlagPop: false, toastMessagePop: '', toastSuccessPop: false });
    }

    setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
        this.setState({ toastFlagPop: isEnabled, toastMessagePop: message, toastSuccessPop: isSucces });
        if (isAutoHide) {
            setTimeout(() => {
                this.onCloseToastPop();
            }, 3000);
        }
    }

    onModalFormReset = () => {
        this.onResetFormData();
        this.setState({ isClientAddSliderOpen: false, isContactAddSliderOpen: false });
        // Do Nothing 
    }

    refreshParent = (userData) => {
        // this.contactModal.current.handleModelClose();
        this.onModalFormReset();
        let clObj = [];
        this.props.handleClientChange(clObj);
        setTimeout(() => {
            this.props.handleClientChange(this.state.clientSelected);
        }, 350);
    }


    openAddNewContact = () => {

        let addContactClicked = this.state.addContactClicked + 1;
        this.setState({ addContactClicked: addContactClicked, isContactAddSliderOpen: true }, () => {

            // this.contactModal.current.handleOpenModal();
            setTimeout(() => {
                let contactModalPop = document.getElementById('contactModalPop');
                if (contactModalPop) {
                    contactModalPop.style.width = '650px';
                }
            }, 500);
        })
    }

    renderTooltip(name, props) {
        return (
            <Tooltip id={name} style={{
                opacity: 0.4,
            }} {...props} >
                {name}
            </Tooltip>
        );
    }

    onGetGoogleLocClick = (e) => {
        this.typeahead.clear()
        this.props.onGetGoogleLoc(e);
    }

    // filterByCallback = (option, props)=>{
    //     //console.log(option,props)
    //     //option.name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1
    // }   

    onSaveFormData = (e) => {
        let saveFormDataClicked = this.state.saveFormDataClicked + 1;
        this.setState({ saveFormDataClicked });
    }

    onSaveQuickFormData = (e) => {

        if (formValid(this.state)) {
            let quickData = {
                company_name: this.state.quickData.companyName,
                departments: JSON.stringify(this.state.quickData.departments),
                web_site: this.state.quickData.websiteUrl,
                first_name: this.state.quickData.firstName,
                last_name: this.state.quickData.lastName,
                email: this.state.quickData.emailAddress,
                contact_number: this.state.quickData.contactNumber,
                position: this.state.quickData.position,
                category: this.state.quickData.category,
                send_email_verification: this.state.quickData.sendEmailVerification
            }
            this.props.clientQuickAddAction(quickData);
        } else {
            let formErrors = this.state.formErrors;
            if (this.state.quickData.companyName == null) {
                formErrors.companyName = MSG_REQUIRED;
            }
            if (this.state.quickData.departments.length == 0) {
                formErrors.departments = MSG_REQUIRED;
            }
            if (this.state.quickData.firstName == null) {
                formErrors.firstName = MSG_REQUIRED;
            }
            if (this.state.quickData.lastName == null) {
                formErrors.lastName = MSG_REQUIRED;
            }
            if (this.state.quickData.emailAddress == null) {
                formErrors.emailAddress = MSG_REQUIRED;
            }
            if (this.state.quickData.category == null) {
                formErrors.category = MSG_REQUIRED;
            }
            if (this.state.quickData.contactNumber == null) {
                formErrors.contactNumber = MSG_REQUIRED;
            }
            this.setState({ formErrors });
        }
    }

    onResetFormData = () => {
        let quickData = {
            companyName: null,
            departments: [],
            websiteUrl: '',
            firstName: null,
            lastName: null,
            contactNumber: null,
            emailAddress: null,
            position: '',
            category: null,
            sendEmailVerification: false
        };

        this.setState({ quickData });
    }


    openModal = () => {
        this.resetFormErrors();
        this.props.aflt_departmentsListAction({ associated: '1' });
        this.callClientCategoryList();
        //   this.modal.current.handleOpenModal();   
        this.setState({ isClientAddSliderOpen: true });
    }

    callClientCategoryList = () => {
        this.props.clientCategoryList();
    }

    resetFormErrors = () => {
        let formErrors = this.state.formErrors;
        formErrors.companyName = "";
        formErrors.departments = "";
        formErrors.firstName = "";
        formErrors.lastName = "";
        formErrors.contactNumber = "";
        formErrors.emailAddress = "";
        formErrors.category = "";
        this.setState({ formErrors });
    }

    onHandleChange = (e) => {

        const { name, value, checked } = e.target;

        let formErrors = this.state.formErrors;

        switch (name) {
            case 'companyName':
                formErrors.companyName =
                    value.length <= 0
                        ? MSG_REQUIRED
                        : ""
                break;
            case 'firstName':
                formErrors.firstName =
                    value.length <= 0
                        ? MSG_REQUIRED
                        : ""
                break;
            case 'lastName':
                formErrors.lastName =
                    value.length <= 0
                        ? MSG_REQUIRED
                        : ""
                break;
            case 'contactNumber':
                formErrors.contactNumber =
                    value.length <= 0
                        ? MSG_REQUIRED
                        : ""
                break;
            case 'emailAddress':
                formErrors.emailAddress =
                    value.length <= 0 || validateEmail(value) === false
                        ? MSG_REQUIRED
                        : ""
                break;
            case 'category':
                formErrors.category = value === "0" ? MSG_REQUIRED : ""
                break;

            default:
                break;
        }

        this.setState((prevState) => ({
            quickData: {
                ...prevState.quickData,
                [name]: name === 'sendEmailVerification' ? checked : value,
            },
            formErrors,
        }));

    }

    onPhoneInputChange = (value, data, event, formattedValue) => {
        let quickData = this.state.quickData;
        let formErrors = this.state.formErrors;
        quickData['contactNumber'] = formattedValue;
        formErrors.contactNumber = value.trim() === data.dialCode ? MSG_REQUIRED : ""
        formErrors.contactNumber = formattedValue.trim().length < 5 ? MSG_REQUIRED : ""

        this.setState({ formErrors, quickData });
    }

    setStateUpdate(activity, status, clientProfActivity, clientCategoryData, errorData) {
        let formErrors = this.state.formErrors;
        if (activity === types.CLIENT_QUICK_ADD_SUCCESS) {
            this.props.refreshClientList();
            this.handleClientChange([{ id: this.props.quickResponse.profile_id, company_name: this.props.quickResponse.company_name }])
            //this.modal.current.handleModelClose();
            this.onModalFormReset();
            if (this.props.quickResponse.verification_email_send) {
                this.setToasterStatePop(true, MSG_CLIENT_ADD_SUCCESS, true, true);
            } else {
                this.setToasterStatePop(true, MSG_NO_VERIFICATION_CLIENT_ADD_SUCCESS, true, true);
            }

        } else if (activity === types.CLIENT_QUICK_ADD_ERROR) {
            if (status === 400) {
                if (errorData.hasOwnProperty('company_name')) {
                    formErrors.companyName = errorData.company_name[0];
                } else if (errorData.hasOwnProperty('email')) {
                    formErrors.emailAddress = errorData.email[0];
                } else {
                    this.setToasterStatePop(true, JSON.stringify(errorData), false);
                }
                this.setState(formErrors);
            } else {
                //this.modal.current.handleModelClose();
                this.onModalFormReset();
                if (errorData.hasOwnProperty('message')) {
                    this.setToasterStatePop(true, errorData.message, false);
                } else {
                    this.setToasterStatePop(true, JSON.stringify(errorData), false);
                }
            }

        }
    }

    componentDidUpdate(prevProps) {
        const { activity, status, clientProfActivity, clientCategoryData, errorData, affiliateDeptActivity } = this.props;

        if (activity !== prevProps.activity) {
            this.setStateUpdate(activity, status, clientProfActivity, clientCategoryData, errorData);
            this.props.clearAction();
        }

        if (affiliateDeptActivity && affiliateDeptActivity !== prevProps.affiliateDeptActivity) {
            let arrRespDept = affiliateDeptActivity.split('~~');

            if (arrRespDept[0] === types.DEPARTMENT_LIST_AFFILIATE_SUCCESS) {
                if (this.props.hasOwnProperty('affiliateDepartmentsList')) {
                    if (this.props.affiliateDepartmentsList.length === 0) {
                        this.setState({ departmentsList: [] }, () => {
                            this.loadMultiSelDeptValues();
                        });
                    }
                    else {
                        this.setState({ departmentsList: this.props.affiliateDepartmentsList }, () => {
                            this.loadMultiSelDeptValues();
                        });
                    }
                }
            }
        }
    }

    render() {
        const { clients, clientContacts, locations, formErrors, eventData, isClientPage, eventId, eventStatus, initialValidation } = this.props;

        const { eventNoEditStatuses } = this.state;

        //let timeZone = getUserTimeZone(window.location); 

        let selectedStartDate = '';
        let selectedEndDate = '';
        let selectedStartTime = '';
        let selectedEndTime = '';
        let defaultValue = new Date();
        if (this.props.defaultStartDate) {
            defaultValue = new Date(this.props.defaultStartDate.valueOf());
            defaultValue = defaultValue.setDate(defaultValue.getDate() - 1)

        }
        if (eventData.startDate !== null) {
            if (eventId && Number(eventId) > 0) {
                let sTime = String(eventData.startDate).trim();
                let arrtime = sTime.split('T');
                selectedStartDate = new Date(sTime.substring(0, 10) + " 00:00:00"); // EDIT 
                selectedStartTime = arrtime[1];
            }
            else {
                let def_start_date = ''
                if (typeof this.props.defaultStartDate === "string") {
                    def_start_date = new Date(this.props.defaultStartDate + " 00:00:00")
                }
                selectedStartDate = eventData.startDate ? new Date(eventData.startDate + " 00:00:00") : def_start_date;
            }
        }
        if (eventData.endDate !== null) {
            if (eventId && Number(eventId) > 0) {
                selectedEndDate = new Date(String(eventData.endDate).substring(0, 10) + " 00:00:00"); // EDIT 
            }
            else {
                let def_end_date = ''
                if (typeof this.props.defaultStartDate === "string") {
                    def_end_date = new Date(this.props.defaultStartDate + " 00:00:00")
                }
                selectedEndDate = eventData.endDate ? new Date(eventData.endDate + " 00:00:00") : def_end_date;
            }

        }
        if (selectedStartTime === '' && eventData.startTime !== null) {
            selectedStartTime = new Date(eventData.startTime);
        }
        if (selectedEndTime === '' && eventData.endTime !== null) {
            selectedEndTime = new Date(eventData.endTime);
        }

        let formattedlocation = [];
        if (locations.length > 0) {
            locations.forEach(el => {
                el.location['id'] = el.id;
                formattedlocation.push(el.location);
            });
        }

        let clientOptions = [];
        if (clients.length > 0) {
            clients.forEach(item => {
                clientOptions.push({ id: item.id, name: item.company_name });
            });
        }

        let clientContactOptions = [];
        if (clientContacts.length > 0 && eventData.clientId > 0) {
            clientContacts.forEach(item => {
                clientContactOptions.push({ id: item.id, name: item.user.first_name + ' ' + item.user.last_name, firstName: item.user.first_name });
            });
        }

        let selectedClient = clientOptions.filter(x => x.id === eventData.clientId);
        let selectedContact = clientContactOptions.filter(x => x.id === eventData.clientContactId);
        //let clientEditable = 1;
        //if(!isClientPage && eventData.hasOwnProperty('created_by') && eventData.created_by==='client') clientEditable = 0; 

        let validationMsgStr = '';
        if (this.props.validationMsgArr.length) {
            this.props.validationMsgArr.forEach(item => {
                validationMsgStr += validationMsgEventAdd[item] ? validationMsgEventAdd[item] + '' : '';
            });
            //EXCEPTION HANDLING 
            if (validationMsgStr === '') validationMsgStr = validationMsgEventAdd['common_error'];
            else validationMsgStr = validationMsgEventAdd['common_header'] + validationMsgStr;
        }
        // let disableEditAddress = (!DISABLE_LOC_DET_EDIT && eventData.location && eventData.location.length > 0) ? false : true;
        let disableEditAddress = (!DISABLE_LOC_DET_EDIT && eventData.location && eventData.location.length > 0) ? false : false;
        return (
            <React.Fragment>
                <Form autoComplete="off" className="quote-add">
                    <Toast toastDescription={this.state.toastMessagePop} toastFlag={this.state.toastFlagPop} toastSuccess={this.state.toastSuccessPop} closeToast={this.onCloseToastPop} />
                    {validationMsgStr.length > 1 && <div className="row">
                        <div className="col-md-12 div-border text-left text-red paddingBottom5">{ReactHtmlParser(validationMsgStr)}</div>
                    </div>}

                    <div className="row">
                        {!isClientPage &&
                            <>
                                <div className="col-md-6">
                                    <CustomTitle title={LBL_CLIENT_DETAILS} className="mb-4" />
                                    <div className="form-group">

                                        <label>{LBL_CLIENT} *</label>
                                        {/* {this.props.eventActionTitle !== LBL_EDIT_EVENT && <div className="float-right"><label><Link onMouseDown={(e) => this.openModal()} to="#">{'+ ' + LBL_ADD_NEW_CLIENT}</Link></label></div>} */}
                                        <div className="form-group select-input">

                                            <Typeahead
                                                selected={selectedClient}
                                                id="client"
                                                labelKey="name"
                                                options={clientOptions}
                                                placeholder="Choose a client..."
                                                inputProps={{ name: 'clientId', className: (formErrors.clientId.length > 0 && initialValidation) ? "input-error" : '' }}
                                                onChange={(s) => this.handleClientChange(s)}
                                                onInputChange={this.props.handleRemoveClient}
                                                disabled={this.props.eventActionTitle === LBL_EDIT_EVENT ? true : false}
                                            />
                                        </div>


                                    </div>
                                </div>
                            </>
                        }
                        <div className="col-md-6">
                            <CustomTitle title={LBL_CONTACT_DETAILS} className="mb-4" />
                            <div className="">
                                <label>{LBL_CLIENT_CONTACT}</label>
                                {Number(this.state.clientId) > 0 &&
                                    <div className="float-right">
                                        <label><Link onMouseDown={this.openAddNewContact} to="#">{'+ ' + LBL_ADD_NEW_CONTACT}</Link></label></div>}
                                <div className="">

                                    <Typeahead
                                        //filterBy={this.filterByCallback}
                                        selected={selectedContact}
                                        id="client-contact"
                                        labelKey="name"
                                        options={clientContactOptions}
                                        placeholder="Choose a contact..."
                                        inputProps={{ name: 'clientContactId', className: (formErrors.clientContactId.length > 0 && initialValidation) ? "input-error" : '' }}
                                        onChange={(s) => this.props.handleClientContactChange(s)}
                                        onInputChange={this.props.handleRemoveContact} >
                                        {({ onClear, selected }) => (
                                            <div className="rbt-aux">
                                                {!!selected.length && <ClearButton onClick={this.props.handleRemoveContact} />}
                                            </div>
                                        )}
                                    </Typeahead>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">

                        <div className='col-md-12'>
                            <CustomTitle title={LBL_PROJECT_DETAILS} className="my-4" />
                            <div className="form-group">
                                <label>{LBL_EVENT} Title</label>
                                <div className="text-input"><input type="text" placeholder=" " name="eventTitle" onChange={this.props.onHandleChange} className={(formErrors.eventTitle.length > 0 && initialValidation) ? "input-error" : ''} value={eventData.eventTitle || ''} maxLength={120} /></div>
                            </div>
                        </div>
                    </div>
                    <div className={eventId ? 'row' : 'hide'}>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_PO}</label>
                                <div className={eventData.status !== Number(eventStatus[2].statusCode) && eventData.status !== Number(eventStatus[3].statusCode) ? 'text-input text-optional' : 'text-input'}><input type="text" name="poNumber" onChange={this.props.onHandleChange} value={eventData.poNumber || ''} disabled={eventData.status !== Number(eventStatus[2].statusCode) && eventData.status !== Number(eventStatus[3].statusCode)} /></div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>#{LBL_QUOTE} no</label>
                                <div className="text-input text-optional"><input type="text" placeholder="Not generated" name="quoteNumber" onChange={this.props.onHandleChange} value={eventData.quoteNumber || 'Not generated'} disabled /></div>
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-12">
                            <div className='d-flex align-items-center justify-content-between'>
                                <label className='mb-0'>Location</label>
                                <div className="custom-checkbox">
                                    <input type="checkbox" id="noLocationFound" name="noLocationFound" onChange={this.onGetGoogleLocClick} checked={eventData.noLocationFound} disabled={eventNoEditStatuses.includes(eventData.status)} />
                                    <label className="checkbox" htmlFor="noLocationFound"></label>
                                    <label className="labeltext mr-0" htmlFor="noLocationFound">Couldn't find the location? Get it from Google
                                        <sup>
                                            <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderTooltip('Type address to get the location from google map')}
                                            >
                                                <button type="button" className="tootltip-btn">
                                                    <i className="las la-question-circle"></i>
                                                </button>
                                            </OverlayTrigger>
                                        </sup>
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className={eventData.noLocationFound ? 'hide' : 'text-input'} >
                                    <AsyncTypeahead
                                        isLoading={false}
                                        name="location"
                                        id="locationSearch"
                                        minLength={3}
                                        labelKey="location"
                                        onChange={selected => this.props.onSelectLocation(selected)}
                                        options={formattedlocation}
                                        placeholder="Type a location..."
                                        onSearch={this.props.onsearchLocation}
                                        searchText="Searching"
                                        promptText="Type a location..."
                                        disabled={this.props.disableLocationSearch || eventNoEditStatuses.includes(eventData.status)}
                                        ref={(ref) => this.typeahead = ref}
                                        inputProps={{ className: (formErrors.locationId.length > 0 && initialValidation) ? "input-error" : '' }}
                                    />
                                </div>
                                <div className={eventData.noLocationFound ? 'text-input' : 'hide'} >
                                    <LocationSearchInput name="googleLocation" googleLocSelect={this.props.googleLocSelect} disabled={this.props.disableLocationSearch || eventNoEditStatuses.includes(eventData.status)} resetGoogleLocation={this.props.resetGoogleLocation} className={(formErrors.locationId.length > 0 && initialValidation) ? "input-error" : ''} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_VENUE}</label>
                                <div className={!eventData.noLocationFound ? 'text-input text-optional' : 'text-input'}><input type="text" placeholder=" " name="venue" onChange={this.props.onHandleChange} value={eventData.venue || ''} maxLength={125} disabled={disableEditAddress} /></div>
                                {/* disabled={!eventData.noLocationFound} */}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                &nbsp;
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Street 1</label>
                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" placeholder=" " name="streetOne" onChange={this.props.onHandleChange} value={eventData.streetOne || ''} maxLength={50} disabled={disableEditAddress} /></div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Street 2</label>
                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" placeholder=" " name="streetTwo" onChange={this.props.onHandleChange} value={eventData.streetTwo || ''} maxLength={50} disabled={disableEditAddress} /></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>City</label>
                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" placeholder=" " name="city" onChange={this.props.onHandleChange} value={eventData.city || ''} maxLength={50} className={(formErrors.city.length > 0 && initialValidation) ? "input-error" : ''} disabled={disableEditAddress} /></div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>State</label>
                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" placeholder=" " name="state" onChange={this.props.onHandleChange} value={eventData.state || ''} maxLength={50} className={(formErrors.state.length > 0 && initialValidation) ? "input-error" : ''} disabled={disableEditAddress} /></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Country</label>
                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" placeholder=" " name="country" onChange={this.props.onHandleChange} value={eventData.country || ''} maxLength={50} className={(formErrors.country.length > 0 && initialValidation) ? "input-error" : ''} disabled={disableEditAddress} /></div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Post code</label>
                                <div className={disableEditAddress ? "text-input text-optional" : "text-input"}><input type="text" placeholder=" " name="postcode" onChange={this.props.onHandleChange} value={eventData.postcode || ''} maxLength={10} className={(formErrors.postcode.length > 0 && initialValidation) ? "input-error" : ''} disabled={disableEditAddress} /></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Start date</label>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="calendar-input">
                                            <DatePicker
                                                selectsStart
                                                startDate={defaultValue}
                                                selected={selectedStartDate}
                                                onChange={selected => this.props.onStartDateChange(selected)}
                                                name="startDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                //maxDate={new Date()}
                                                // minDate={new Date()}
                                                fixedHeight
                                                className={(formErrors.startDate.length > 0 && initialValidation) ? "input-error" : ''}
                                                disabled={eventNoEditStatuses.includes(eventData.status)}
                                            />
                                        </div>
                                    </div>
                                    {/*<div className="col-md-6">
                                            <div className="time-input ">
                                                <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'startTime', className:formErrors.startTime.length >0 ? "input-error" : ''}}  value={eventData.startTime === '' ? selectedStartTime :  eventData.startTime} onChange={selected=>this.props.onStartTimeChange(selected)}  onBlur={selected=>this.props.onStartTimeBlur(selected)} />
                                            </div>
                                        </div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>End date</label>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="calendar-input">
                                            <DatePicker
                                                selected={selectedEndDate}
                                                onChange={selected => this.props.onEndDateChange(selected, 2)}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                minDate={selectedStartDate}
                                                fixedHeight
                                                className={(formErrors.endDate.length > 0 && initialValidation) ? "input-error" : ''}
                                                disabled={eventNoEditStatuses.includes(eventData.status)}
                                            />
                                        </div>
                                    </div>
                                    {/*<div className="col-md-6">
                                        <div className="time-input ">
                                            <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', className:formErrors.endTime.length >0 ? "input-error" : ''}}  value={eventData.endTime === '' ? selectedEndTime :  eventData.endTime} onChange={selected=>this.props.onEndTimeChange(selected)} onBlur={selected=>this.props.onEndTimeBlur(selected)}/>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Notes</label>
                                <textarea rows="4" className="form-control" name="eventNotes" onChange={this.props.onHandleChange} value={eventData.eventNotes || ''}></textarea>
                            </div>
                        </div>
                    </div>
                </Form>

                {/* <ModalWindow modalId="contactModalPop" ref={this.contactModal} header={LBL_ADD_NEW_CLIENT_CONTACT} saveFormData={(e) => this.onSaveFormData(e)} resetModalForm={this.onModalFormReset} type="save" >
                    <ClientContactAdd saveFormDataClicked={this.state.saveFormDataClicked} refreshParent={this.refreshParent} clientId={this.state.clientId} setToasterStatePop={this.setToasterStatePop} addContactClicked={this.state.addContactClicked} />
                </ModalWindow> */}

                {/* <ModalWindow ref={this.modal} header="Basic Details" saveFormData={ (e)=>this.onSaveQuickFormData(e)} resetModalForm={this.onModalFormReset} type="save">
                  <QuickAdd clientCategoryBasicData={this.props.clientCategoryData} onHandleChange={(e) => this.onHandleChange(e)} onPhoneInputChange={this.onPhoneInputChange} {...this.state} sendEmail={this.state.quickData.sendEmailVerification}/>
               </ModalWindow>  */}


                <CommonSlider
                    isOpen={this.state.isContactAddSliderOpen}
                    className="client-quick-add-slider"
                >
                    <div className='mb-1 text-right' style={{ cursor: 'pointer' }} onClick={this.onModalFormReset}> <img src={iconClose} alt="Close Icon" /></div>
                    <ClientContactAdd id="quotes-contact-add" saveFormDataClicked={this.state.saveFormDataClicked} refreshParent={this.refreshParent} clientId={this.state.clientId} setToasterStatePop={this.setToasterStatePop} addContactClicked={this.state.addContactClicked} clientName={this.state.clientSelected?.[0]?.name ?? ""} />

                    <div className=" py-4">
                        <button type="button" className="btn btn-primary mr-3 px-3 py-2" id="save" name="save" onClick={(e) => this.onSaveFormData(e)}>{LBL_FINISH_QUOTE}</button>

                        <button type="button" className="btn btn-secondary btn-cancel px-3 py-2" data-dismiss="modal" onClick={this.onModalFormReset}>{LBL_CANCEL}</button>
                    </div>

                </CommonSlider>

                <CommonSlider
                    isOpen={this.state.isClientAddSliderOpen}
                    className="client-quick-add-slider"
                >
                    <div className='mb-1 text-right' style={{ cursor: 'pointer' }} onClick={this.onModalFormReset}> <img src={iconClose} alt="Close Icon" /></div>
                    <QuickAdd clientCategoryBasicData={this.props.clientCategoryData} onHandleChange={(e) => this.onHandleChange(e)} onPhoneInputChange={this.onPhoneInputChange} {...this.state} sendEmail={this.state.quickData.sendEmailVerification} deptMultiSelList={this.state.deptMultiSelList} handleChangeMultiSel={this.handleChangeMultiSel} className="client-quick-add" id="client-quick-add" />

                    <div className=" py-4">
                        <button type="button" className="btn btn-primary mr-3 px-3 py-2" id="save" name="save" onClick={(e) => this.onSaveQuickFormData(e)}>{LBL_FINISH_QUOTE}</button>

                        <button type="button" className="btn btn-secondary btn-cancel px-3 py-2" data-dismiss="modal" onClick={this.onModalFormReset}>{LBL_CANCEL}</button>
                    </div>
                </CommonSlider>

            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        clientCategoryData: state.clients.clientCategoryListData,
        status: state.clients.status,
        activity: state.clients.activity,
        clientProfActivity: state.clients.clientProfActivity,
        quickResponse: state.clients.quickResponse,
        errorData: state.clients.errorData,
        affiliateDeptActivity: state.afltDepartments.affiliateDeptActivity,
        affiliateDepartmentsList: state.afltDepartments.affiliateDepartmentsList,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clientQuickAddAction: data => clientQuickAddAction(data),
        clientCategoryList: clientCategoryList,
        clearAction: clearAction,
        aflt_departmentsListAction: aflt_departmentsListAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(QuoteAdd);